import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of, firstValueFrom, map, take, catchError } from 'rxjs';
import { FirebaseService } from '../firebase/firebase.service';
import { DocumentData, Firestore, Query, collection, query, where } from '@angular/fire/firestore';
import { User } from '../../models/user.model';
import { User as UserFirebase } from 'firebase/auth';
import * as fromUserActions from '../../store/actions';
import { Store } from '@ngrx/store';

@Injectable({
    providedIn: 'root',
})
export class AuthService {

    constructor(
        private readonly router: Router,
        private readonly firebaseService: FirebaseService,
        private readonly firestore: Firestore,
        private readonly store: Store<{ user: User }>
    ) { }

    public login(token: string): void {
        localStorage.setItem('token', token);
        this.router.navigate(['/home/teams']);
    }

    public async loginGooglePopUp(): Promise<{ message: string; userData: User | undefined; }> {
        let message = 'User not logged';
        let userData;
        const userCredential: UserFirebase = await this.firebaseService.loginGooglePopUp();
        if (userCredential) {
            userData = await this.getUserByEmail(userCredential.email!);
            if (userData) {
                this.login(userData.uuid!);
                message = 'User logged'
            } else {
                message = 'User not founded'
                userData = { name: userCredential.displayName, email: userCredential.email } as User;
            }
        }
        return { message, userData };
    }

    public isLogged(): Observable<{ logged: boolean; user: User | undefined }> {
        const token = localStorage.getItem('token');
        if (token) {
            return this.getUserByUuid(token).pipe(
                map(
                    (user) => {
                        if (user) {
                            if (user.trainerRef) {
                                user.trainerId = user.trainerRef.id;
                                delete user.trainerRef;
                            }
                            delete user.teamRef;

                            this.store.dispatch({ type: fromUserActions.ADD_USER, data: user });
                            return { logged: true, user };
                        } else {
                            localStorage.removeItem('token');
                            this.store.dispatch({ type: fromUserActions.DELETE_USER });
                            return { logged: false, user: undefined };
                        }
                    }
                ),
                catchError(
                    () => {
                        localStorage.removeItem('token');
                        this.store.dispatch({ type: fromUserActions.DELETE_USER });
                        return of({ logged: false, user: undefined });
                    }
                )
            );
        }
        return of({ logged: false, user: undefined });
    }

    public logout(): void {
        localStorage.removeItem('token');
        this.store.dispatch({ type: fromUserActions.DELETE_USER });
        this.router.navigate(['/login']);
    }

    public getUserByEmail(email: string): Promise<User> {
        const ref: Query<DocumentData, DocumentData> = query(
            collection(this.firestore, 'users'),
            where('email', '==', email)
        );
        return firstValueFrom(this.firebaseService.getDataOfCollectionByField(ref).pipe(take(1), map((value) => value[0]))) as any;
    }

    public getUserByUuid(uuid: string): Observable<User> {
        const ref: Query<DocumentData, DocumentData> = query(
            collection(this.firestore, 'users'),
            where('uuid', '==', uuid)
        );
        return this.firebaseService.getDataOfCollectionByField(ref).pipe(take(1), map((value) => value[0])) as any;
    }
}